import services from './services';
import {
    GetERP_OrderById
} from '@api/orderApi.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import $http from '$http';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import Uploader from 'uploader';
import viewPhoto from 'src/common/js/viewPhoto';


//组件
// import baseInfoForm from 'agent-base-info';

export default {
    mixins: [services],
    props: {
        value: {}
    },
    data() {
        return {
            dialogVisible: false,
            OrderData: {},
            confirmFormData: this.getConfirmFormData(),
            changeRadio: "",
            dialogTabsVisible: false,
            selectTemp: {},
            selectTemp2: {},
            returnConfigList: [],
            isShow: false,
            changeProductList: [],
            totalNum1: 0,
            totalNum2: 0, //可退换简装数
            show1: true,
            activeName: '1',
            num2: [],
            changePic: [],
            uploadSwitch: true,

        }
    },
    methods: {
        //选择资源包
        chooseList(index, item, itemList) {
            for (var i = 0; i < this.returnConfigList.length; i++) {
                for (var j = 0; j < this.returnConfigList[i].List.length; j++) {
                    this.returnConfigList[i].List[j].active = false;
                }
            }
            item.active = true;
            let ProName = item.ProName;
            item.ProName = " ";
            item.ProName = ProName;
        },
        //修改资源包
        changeBtn() {
            this.isShow = true;

            for (let i = 0; i < this.changeProductList.length; i++) {
                this.changeProductList[i].maxNum = Infinity;
            }
        },
        //添加资源包
        addTableCell() {
            this.changeProductList.push({
                "ReturnProId": 0,
                "ReturnPro": "--",
                "ReturnProName": "",
                "ChangeProId": 0,
                "ChangePro": "--",
                "ChangeProName": "",
                "ReturnNum": 0,
                "Type": 0
            });
        },
        //获取资源包
        getConfig(item) {
            this.selectTemp = item; //选择资源包列表数据后，表格资源包名称相应改变
            this.selectTemp2 = item;
            this.selectTemp2.num = item.ReturnNum
            this.getReturnConfig(item);
        },
        viewPicture(url, list) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: url,
                    id: ""
                }]
            });
        },
        delPicture(Url, list) {
            if (list.length > 0) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].Url == Url) {
                        list.splice(i, 1);
                    }
                }
            }
        },

        // 确定
        enSure() {
            //lg(this.returnConfigList)
            for (var i = 0; i < this.returnConfigList.length; i++) {
                for (var j = 0; j < this.returnConfigList[i].List.length; j++) {
                    if (this.returnConfigList[i].List[j].active) {
                        //如果表格存在这个资源包，提示
                        for (let k = 0; k < this.changeProductList.length; k++) {
                            if (this.returnConfigList[i].List[j].ProId == this.changeProductList[k].ReturnProId) {
                                this.$notify({
                                    title: '提示',
                                    message: '实际换货列表已存在该资源包!',
                                    type: 'warning'
                                });
                                return;
                            }
                        }
                        //偶数为上册
                        if (this.returnConfigList[i].List[j].ProId % 2 == 0) {
                            //if()
                            this.selectTemp2.ChangePro = this.returnConfigList[i].List[j + 1].ProName + '*' + this.selectTemp2.num;
                        } else {
                            this.selectTemp2.ChangePro = this.returnConfigList[i].List[j - 1].ProName + '*' + this.selectTemp2.num;
                        }
                        this.selectTemp.ReturnProName = this.returnConfigList[i].List[j].ProName;
                        this.selectTemp.ReturnProId = this.returnConfigList[i].List[j].ProId;
                        this.selectTemp.Type = this.returnConfigList[i].List[j].Type;
                        this.dialogTabsVisible = false;
                    }
                }
            }
        },
        handleChange(num) {
            this.$nextTick(function () {
                let $obj = this.changeProductList;
                for (let i = 0; i < this.num2.length; i++) {
                    $obj[i].ReturnNum = this.num2[i]
                    $obj[i].ChangeProName = $obj[i].ChangePro.substring(0, $obj[i].ChangePro.indexOf('*'))
                    $obj[i].ChangePro = $obj[i].ChangeProName + '*' + this.num2[i]
                    this.totalNum1 = 0;
                    this.totalNum2 = 0;
                    for (let i = 0; i < $obj.length; i++) {
                        if ($obj[i].Type == 0) {
                            this.totalNum1 += $obj[i].ReturnNum
                        } else {
                            this.totalNum2 += $obj[i].ReturnNum
                        }
                    }
                    if (!this.isShow) {
                        this.changeProductList[i].num = this.num2[i]
                    }
                }


            })
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        dialogClose() {
            this.changeRadio = '';
            this.isShow = false;
            this.dialogVisible = false;

        },
        getConfirmFormData() {
            return cloneDeep({
                "OrderId": 0,
                "ReturnRemark": "",
                "NewList": [],
                "ActualList": [],
                ReturnPic: ''
            });
        },
        show(options) {
            this.dialogVisible = true;
            this.confirmFormData = this.getConfirmFormData();
            this.getInfo(options);
            if (this.uploadSwitch) {
                this.uploadSwitch = false;

                this.$nextTick(function () {
                    var self = this;
                    let uploaderFactory = new Uploader();
                    let uploader1 = uploaderFactory.generator({
                        container: 'container-1',
                        browse_button: 'upload-btn-1',
                        multi_selection: true, //上传多张
                        //开始上传
                        uploadBegin: function () {

                        },
                        //上传结束并得到文件
                        uploaded: function (file) {
                            self.changePic.push(file)
                        }
                    });
                    uploaderFactory.init();
                });
            }
        },
        submit() {
            this.confirmFormData.NewList = [];
            this.confirmFormData.ActualList = [];
            let changeTotalNum1 = 0;
            let changeTotalNum2 = 0; //换货简装数

            for (let i = 0; i < this.num2.length; i++) {
                if (this.num2[i] > 0) {
                    this.confirmFormData.ActualList.push({
                        ActualProId: this.changeProductList[i].ReturnProId,
                        ActualNum: this.num2[i]
                    });

                    if (this.changeProductList[i].Type == 0) {
                        changeTotalNum1 += this.num2[i]
                    } else {
                        changeTotalNum2 += this.num2[i]
                    }

                }
            }
            for (let i = 0; i < this.confirmFormData.ActualList.length; i++) {
                //上册
                if (this.confirmFormData.ActualList[i].ActualProId % 2 == 0) {
                    this.confirmFormData.NewList.push({
                        ChangeProId: this.confirmFormData.ActualList[i].ActualProId + 1,
                        ChangeNum: this.num2[i]
                    })
                } else {
                    this.confirmFormData.NewList.push({
                        ChangeProId: this.confirmFormData.ActualList[i].ActualProId - 1,
                        ChangeNum: this.num2[i]
                    })
                }
            }
            this.confirmFormData.ReturnPic = this.changePic.map(item => item.Url).toString();
            //lg(this.confirmFormData)
            if (this.confirmFormData.ActualList.length <= 0) {
                this.$notify({
                    title: '提示',
                    message: '请配置实际换货数量!',
                    type: 'warning'
                });
            } else {
                this.ReturnOrderConfirm(this.confirmFormData)
                this.changePic = [] //初始化图片
            }

        }
    },
    mounted() {

    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/Exchange/components/returnOrderConfirm/vm.js